import { useEffect } from "react";
import { useAppSettings } from "../context/AppSettingsContext";
import { APPOINTMENT_STATUS } from "../constants";
import { APPOINTMENT_LINK_PARAM } from "../constants/Appointment";

/**
 * Removes `appointmentId` from the address bar when it names the given message.
 * Uses history.replaceState rather than the router so the auth guard, which depends on
 * location.search, does not run again; only a later refresh sees the shorter URL.
 */
function removeAppointmentIdFromUrl(messageId) {
  const url = new URL(window.location.href);
  const appointmentId = url.searchParams.get(APPOINTMENT_LINK_PARAM);
  if (!appointmentId || appointmentId.toLowerCase() !== messageId?.toLowerCase()) {
    return;
  }

  url.searchParams.delete(APPOINTMENT_LINK_PARAM);
  window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`);
}

/**
 * Drops the My Schedule `appointmentId` deep link once that appointment is canceled (by either
 * attendee), so refreshing the chat does not point at a canceled appointment. The link is left
 * as it is for any other change.
 */
export function useRemoveCanceledAppointmentLink() {
  const { chatClient } = useAppSettings();

  useEffect(() => {
    if (!chatClient) return;

    const handleMessageUpdated = (event) => {
      if (event?.message?.appointment?.status !== APPOINTMENT_STATUS.CANCELED) return;
      removeAppointmentIdFromUrl(event.message.id);
    };

    chatClient.on("message.updated", handleMessageUpdated);
    return () => {
      chatClient.off("message.updated", handleMessageUpdated);
    };
  }, [chatClient]);
}
